module.exports = __webpack_public_path__ + "img/whats-new-2_cn.09ee7bd.jpg";